const canvas = document.createElement('canvas');
const context = canvas.getContext('2d');

export function getTextWidthByCanvas(text, fontStyle) {
  context.font = fontStyle || '16px'; // 设置字体样式
  const dimension = context.measureText(text);
  return dimension.width;
}

export function stringify(text) {
  return text + '';
}

/**
 * 根据字体大小，内容中文与其他计算文本宽度
 */
export function getTextWidth(text, fontSize) {
  text = stringify(text);

  if (text.length === 0) return 0;

  const chineasePattern = /[\u4e00-\u9fa5]/g;
  let factor = 1;

  // 根据中英文计算文本大小
  return [...text].reduce((num, str) => {
    factor = chineasePattern.test(str) ? 1.6 : 1;
    num += fontSize * factor;
    return num;
  }, 0);
}
